module.exports = __webpack_public_path__ + "static/media/qual-pub-stat.f25eb22f.png";